export default __webpack_public_path__ + "static/media/home-hero.0c32b45a.jpg";